export enum EContractType {
  INDUK = 'induk',
  SPOT = 'spot',
}

export enum EMethodPaymentSPOT {
  FREIGHT = 'freight',
  LUMPSUM = 'lumpsum',
}

export enum EArmadaType {
  MILIK = 'sendiri',
  KONTRAK = 'kontrak',
}

export enum ECargoType {
  BATUBARA = 'batubara',
  LGN = 'lgn',
  BBM = 'bbm',
}
